var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-body-2 pa-md-2 pl-0 form-input-label my-auto form-input-label"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }